export default {
  methods: {
    onlyDigits(event) {
      const persianDigits = /[۰-۹]/;
      const englishDigits = /[0-9]/;
      if (!englishDigits.test(event.key) && !persianDigits.test(event.key)) {
        event.preventDefault();
      }
    },
    normalizeDigits(value) {
      return String(value ?? "")
        .replace(/[۰-۹]/g, (d) => d.charCodeAt(0) - 0x06f0)
        .replace(/[٠-٩]/g, (d) => d.charCodeAt(0) - 0x0660)
        .replace(/\D/g, "");
    },
    onlyDigitsPaste(event) {
      const text = event.clipboardData?.getData("text") || "";
      const digits = this.normalizeDigits(text);
      if (digits === text) return;
      event.preventDefault();
      const input = event.target;
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? input.value.length;
      input.value = input.value.slice(0, start) + digits + input.value.slice(end);
      input.setSelectionRange(start + digits.length, start + digits.length);
      input.dispatchEvent(new Event("input", { bubbles: true }));
    },
  },
};
